module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "pg-boilerplate pgheader",
    attrs: {
      "id": "pg-header",
      "lang": "en"
    }
  }, [_c('h2', {
    attrs: {
      "id": "pg-header-heading",
      "title": ""
    }
  }, [_c('span', {
    attrs: {
      "id": "pg-title-no-subtitle",
      "lang": "en"
    }
  }, [_vm._v("The moving finger")])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "pg-machine-header"
    }
  }, [_c('p', [_c('strong', [_vm._v("Title")]), _vm._v(": The moving finger")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pg-header-authlist"
    }
  }, [_c('p', [_c('strong', [_vm._v("Author")]), _vm._v(": Natalie Sumner Lincoln")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Illustrator")]), _vm._v(": Charles L. Wrenn")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Release date")]), _vm._v(": August 8, 2024 [eBook #74210]")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Language")]), _vm._v(": English")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Original publication")]), _vm._v(": New York and London: D. Appleton and Company")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Credits")]), _vm._v(": D A Alexander, David E. Brown, and the Online Distributed Proofreading Team at https://www.pgdp.net (This file was produced from images generously made available by The Internet Archive)")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "figcenter hide"
  }, [_c('img', {
    attrs: {
      "alt": "cover",
      "id": "img_images_coversmall.jpg",
      "src": "3624747857925452935_coversmall.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8be13bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3186253215635795556_74210-h-0.htm.vue
// module id = 57
// module chunks = 0